module.exports = __webpack_public_path__ + "img/escape-example.3ece01d.png";